import tenkenTheme from "../configs/themes/tenkenTheme";
import { Icon } from "./icons";
import { Tooltip } from "flowbite-react";

function HintIconToolTip({ children, placement = "bottom" }) {
  return (
    <Tooltip
      content={children}
      style="light"
      placement={placement}
      animation={false}
      theme={tenkenTheme.tooltip}
    >
      <Icon name="idea" className="w-5 h-5 object-cover cursor-pointer" />
    </Tooltip>
  );
}

export default HintIconToolTip;
